import { cn, fmtTime } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'
import type { Block } from '../model/types'

interface BlockChipProps {
  block: Block
  /** Пересечение у владельца колонки — предупреждение, не запрет. */
  conflict: boolean
  /** Блок целиком в прошлом: приглушается, но остаётся кликабельным. */
  past: boolean
  /** Низкий блок: остаётся только строка времени и название. */
  compact: boolean
}

/** Свой тон на каждый вид занятости: выход, дело и закрытое время различимы сразу. */
const TONE: Record<Block['kind'], string> = {
  excursion: 'border-l-block-excursion bg-block-excursion-bg',
  task: 'border-l-block-task bg-block-task-bg',
  'time-block': 'border-l-block-off bg-block-off-bg',
}

export function BlockChip({ block, conflict, past, compact }: BlockChipProps) {
  // Отметка выполнения есть только у дела: выход отмечают проведённым, а
  // закрытое время не «делают» вовсе.
  const showDone = block.done && block.kind === 'task'
  return (
    <div
      className={cn(
        'flex h-full min-w-0 flex-col overflow-hidden rounded-control border-l-2 px-1.5 py-1 text-left',
        TONE[block.kind],
        conflict && 'ring-1 ring-block-conflict ring-inset',
        past && 'opacity-55',
        block.cancelled && 'opacity-45',
      )}
    >
      <span className="flex items-center gap-1">
        <span className="mono-num truncate text-[10px] leading-4 text-text-secondary">
          {fmtTime(block.slot.startsAt)}
        </span>
        {conflict && <Icon name="warning" size={10} className="shrink-0 text-warning" />}
        {showDone && <Icon name="check" size={10} className="shrink-0" />}
      </span>
      <span
        className={cn(
          'truncate text-xs leading-4 text-text-primary',
          (block.cancelled || showDone) && 'line-through',
        )}
      >
        {block.title}
      </span>
      {!compact && block.subtitle && (
        <span className="truncate text-[10px] leading-4 text-text-tertiary">{block.subtitle}</span>
      )}
    </div>
  )
}
